import React from 'react';
import './VideoVimeoComponent.scss';
interface VideoVimeoI {
	videoTitle: string;
	videoId: string;
	autoplay: boolean;
	hash?: string;
}

export const VideoVimeoComponent: React.FC<VideoVimeoI> = ({
	autoplay,
	videoId,
	videoTitle,
	hash
}) => {
	let videoSrc = `https://player.vimeo.com/video/${videoId}`;
	const params = new URLSearchParams();
	if (hash) {
		params.append('h', hash);
	}
	params.append('autoplay', autoplay ? '1' : '0');
	params.append('badge', '0');
	params.append('autopause', '0');
	params.append('player_id', '0');
	params.append('app_id', '58479');
	videoSrc += `?${params.toString()}`;
	return (
		<div className='iframe-container'>
			<iframe src={videoSrc} className='iframe-content' title={videoTitle} />
		</div>
	);
};
